import '../../styles/days.scss';

const TwentyOne = () => (
  <div className='days TwentyOne'>
    <img src='https://blog.karenying.com/photo.jpg' alt='karen' />
  </div>
);

export default TwentyOne;
